<template>
  <div class="semapi">
    <!-- 头部banner+表单 -->
    <BannerForm
      :pcBgImg="pcBgImg"
      :landingPageName="landingPageName"
      :showForm="!showScrollForm"
      :logoSrc="logoSrc"
      :hasApi="true"
      title="电子签名开放平台"
      submitText="立即对接系统"
      @msg="handleShowMsg"
      @setShowSuccessDialog="setShowSuccessDialog"
      setHeight="540"
    >
      <template slot="title">
        <div class="semapi-title-content">
          <div class="one-line">电子签名电子合同</div>
          <div class="two-line">开放平台</div>
        </div>
      </template>
      <template slot="desc">
        <div class="semapi-desc">集成e签宝在自己的业务系统实现电子签名</div>
        <div class="semapi-desc">OA、ERP、eHR 、APP、小程序、自研系统...</div>
      </template>
    </BannerForm>
    <!-- banner下方信息 -->
    <div class="banner-bottom">
      <div class="content">
        <div class="item" v-for="(item, index) in bannerBottomData" :key="index">
          <div class="first-line-text">{{ item.firstLineText }}</div>
          <div class="second-line-text">{{ item.secondLineText }}</div>
        </div>
      </div>
    </div>
    <!-- e签宝开放产品体系 -->
    <div class="system-product">
      <SectionCard :isPcFlag="true" title="e签宝开放产品体系" bgColor="#F6F7F8">
        <div class="system-product-content">
          <div class="desc-product">全链路解决用户签署难题</div>
          <div class="product-content">
            <div class="card-item" v-for="item in systemList" :key="item.key">
              <img class="system-img" :src="item.imgSrc" alt="" />
              <div class="card-item-content">
                <div class="title">{{ item.title }}</div>
                <div class="desc">
                  <p v-for="(it, index) in item.descList" :key="index">
                    <span class="round-dot"></span>
                    {{ it }}
                  </p>
                </div>
                <div class="kind-list">
                  <div class="kind-item" v-for="i in item.kindList" :key="i.key">
                    <img class="kind-img" :src="i.icon" alt="" />
                    <p class="kind-text">{{ i.text }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="btns-box">
          <div class="btns">
            <div class="mfsy" @click="showDialog">立即接入</div>
            <div class="zxzx" @click="OnlineConsultationClick">在线咨询</div>
          </div>
        </div>
      </SectionCard>
    </div>
    <!-- 全生态系统连接 -->
    <div class="system-connections">
      <SectionCard :isPcFlag="true" title="全生态系统连接">
        <div class="system-connections-content">
          <div class="desc">支持多终端集成</div>
          <div class="content">
            <img class="connect-one-img" src="@/assets/images/sem-api/connect-one.png" alt="" />
            <img class="connect-two-img" src="@/assets/images/sem-api/connect-two.png" alt="" />
          </div>
        </div>
      </SectionCard>
    </div>
    <!-- 业务系统部署方式 -->
    <div class="arrange-method">
      <SectionCard :isPcFlag="true" title="业务系统部署方式" :bgImg="arrangeMethodBg">
        <div class="arrange-method-content">
          <div class="item-card" v-for="item in arrangeMethodList" :key="item.key">
            <img class="item-card-img" :src="item.imgSrc" alt="" />
            <div class="content">
              <div class="title">{{ item.title }}</div>
              <div class="desc-content">
                <div class="arrange">{{ item.arrangeMethodText }}</div>
                <div class="insert">{{ item.insertMethodText }}</div>
                <div class="applicable">{{ item.applicableObjText }}</div>
                <div class="otherdesc">{{ item.otherDesc }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="btns-box">
          <div class="btns">
            <div class="mfsy" @click="showDialog">立即接入</div>
            <div class="zxzx" @click="OnlineConsultationClick">在线咨询</div>
          </div>
        </div>
      </SectionCard>
    </div>
    <!-- 接入流程 -->
    <div class="flow-path">
      <SectionCard :isPcFlag="true" title="接入流程" :bgImg="flowPathBg">
        <div class="path-content">
          <div class="content">
            <div class="path-left">
              <div class="one-line">
                <div class="item" v-for="item in accessProcessOneLineList" :key="item.key">
                  <div class="item-content" :class="{ 'set-marginright-one-line': item.key == 1 }">
                    <img :src="item.imgSrc" alt="" />
                    <div class="right-content">
                      <p class="title">{{ item.text }}</p>
                      <p class="text">{{ item.desc }}</p>
                    </div>
                  </div>
                  <img class="one-line-arrow" v-if="item.key == 1" src="@/assets/images/sem-saas/flow-arrow.png" alt="" />
                </div>
              </div>
              <div class="two-line">
                <img class="two-line-arrow" src="@/assets/images/sem-saas/flow-arrow.png" alt="" />
              </div>
              <div class="three-line">
                <div class="item" v-for="item in accessProcessTwoLineList" :key="item.key">
                  <div class="item-content" :class="{ 'set-marginright-two-line': item.key == 1 }">
                    <img :src="item.imgSrc" alt="" />
                    <div class="right-content">
                      <p class="title">{{ item.text }}</p>
                      <p class="text">{{ item.desc }}</p>
                    </div>
                  </div>
                  <img class="three-line-arrow" v-if="item.key == 1" src="@/assets/images/sem-saas/flow-arrow.png" alt="" />
                </div>
              </div>
            </div>
            <div class="path-right">
              <img class="qr-img" src="https://www.esign.cn/upload/resources/image/2024/04/09/43148.png" alt="" />
              <p class="qr-desc">扫码获取对接案例和文档</p>
            </div>
          </div>
        </div>
      </SectionCard>
    </div>
    <!-- 无忧服务，极速上线 -->
    <div class="free-service">
      <SectionCard :isPcFlag="true" title="无忧服务，极速上线" :bgImg="freeServiceBg">
        <div class="free-service-content">
          <div class="card-item" v-for="item in freeServiceList" :key="item.key">
            <div class="left-text">
              <div class="title">{{ item.title }}</div>
              <div class="desc">
                <p v-for="(i, index) in item.desc" :key="index">{{ i }}</p>
              </div>
            </div>
            <img class="right-img" :src="item.imgSrc" alt="" />
          </div>
        </div>
      </SectionCard>
    </div>
    <!-- 客户案例 -->
    <OrgList class="customer-cases" :title="orgList.title" :orgTypeList="orgList.orgTypeList" :imgs="orgList.imgs" />
    <!-- 底部备案信息 -->
    <FooterBasis />
    <!-- 左侧计算机小象 -->
    <LeftBar />
    <!-- 立即接入申请弹框 -->
    <UseDialog ref="dialog" :wlCode="true" />
    <!-- 右侧客服 -->
    <!--    <Contact :landingPageName="landingPageName" :saasApiContact="true" />-->
    <!-- 提示信息 -->
    <Message :type="message.type" :title="message.title" :content="message.content" :show.sync="message.show" />
    <!-- 提交完成弹框 -->
    <WeilingSuccessDialog :wlCode="true" v-if="showSuccessDialog" @closeform="showSuccessDialog = false" />
  </div>
</template>

<script>
import dataList from './dataList'
import qiyuMixin from '@/mixins/form/qiyu.js'
export default {
  name: 'semApi',
  mixins: [qiyuMixin],
  components: {
    LeftBar: () => import('@/components/LeftBar/index.vue'),
    BannerForm: () => import('@/components/BannerForm.vue'),
    SectionCard: () => import('@/components/basics/SectionCard.vue'),
    Message: () => import('@/views/extension/components/pc/Message.vue'),
    OrgList: () => import('@/views/extension/components/pc/OrgList.vue'),
    FooterBasis: () => import('@/components/FooterBasis.vue'),
    UseDialog: () => import('@/components/UseDialog.vue'),
    // Contact: () => import('@/components/Contact.vue'),
    WeilingSuccessDialog: () => import('@/components/saasApiSuccessForm.vue'),
  },
  data() {
    return {
      logoSrc: require('@/assets/images/real-estate/logo.png'),
      pcBgImg: require('@/assets/images/sem-api/banner-bg.png'),
      arrangeMethodBg: require('@/assets/images/sem-api/arrange-bg.png'),
      flowPathBg: require('@/assets/images/sem-saas/flow-path.png'),
      freeServiceBg: require('@/assets/images/landing-semsign/third-bg-img.png'),
      qrCodeImg: require('@/assets/images/sem-api/api-qr-code.png'),
      // 落地页名字'e签宝宣传'，因为以上的组件会被多次复用，为了服务商收集数据的时候能够更准确，用这个名字去判断是否需要向服务商发送数据
      landingPageName: 'esignPropagate',
      showScrollForm: false,
      showSuccessDialog: false,
      message: {
        type: '',
        title: '',
        content: '',
        show: false,
      },
      bannerBottomData: dataList.bannerBottomData,
      systemList: dataList.systemList,
      arrangeMethodList: dataList.arrangeMethodList,
      accessProcessOneLineList: dataList.accessProcessOneLineList,
      accessProcessTwoLineList: dataList.accessProcessTwoLineList,
      freeServiceList: dataList.freeServiceList,
      orgList: dataList.orgList,
    }
  },
  computed: {
    qrCodeUrl() {
      return this.$store.state.user.wlQrcode || ''
    },
  },
  mounted() {
    window.addEventListener('scroll', this.scrollHandle, true)
    this.addQiyuScript()
  },
  methods: {
    scrollHandle() {
      const scrollTop = document.documentElement.scrollTop || document.body.scrollTop // 滚动条偏移量
      this.showScrollForm = scrollTop >= 2280
    },
    showDialog() {
      this.$refs.dialog.showDialog()
    },
    OnlineConsultationClick() {
      this.handleNewBaiduService()
    },
    setShowSuccessDialog(v) {
      this.showSuccessDialog = v
    },
    handleShowMsg({ type, title, content }) {
      this.message.type = type
      this.message.title = title
      this.message.content = content
      this.message.show = true
    },
  },
}
</script>

<style lang="less" scoped>
@import './style.less';
</style>
